<template>
  <div>
    <div
      style="
        margin-left: 2em;
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        padding: 12px 16px;
        border-bottom: 1px solid #e5e7eb;
        background: linear-gradient(to right, #f9fafb, #f3f4f6);
      "
    >
      <a
        :href="'/mch/cwc/growth/' + $route.params.visit_id"
        :class="['tab-link', $route.fullPath == '/mch/cwc/growth/' + $route.params.visit_id ? 'active-tab' : '']"
      >
        📈 Growth Monitoring
      </a>
      <a
        :href="'/mch/cwc/immunization/' + $route.params.visit_id"
        :class="['tab-link', $route.fullPath == '/mch/cwc/immunization/' + $route.params.visit_id ? 'active-tab' : '']"
      >
        💉 Immunization
      </a>
      <a
        :href="'/mch/cwc/history/' + $route.params.visit_id"
        :class="['tab-link', $route.fullPath == '/mch/cwc/history/' + $route.params.visit_id ? 'active-tab' : '']"
      >
        📜 History
      </a>
      <a
        :href="'/mch/cwc/notes/' + $route.params.visit_id"
        :class="['tab-link', $route.fullPath == '/mch/cwc/notes/' + $route.params.visit_id ? 'active-tab' : '']"
      >
        📝 Notes
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "cwc_head",
};
</script>

<style scoped>
.tab-link { padding: 8px 14px; border-radius: 6px; font-size: 13px; font-weight: 600; color: #495057; text-decoration: none; background: white; border: 1px solid #e5e7eb; white-space: nowrap; transition: all 0.2s ease; }
.tab-link:hover { background: #f0fff4; color: #276749; }
.active-tab { background: linear-gradient(135deg, #48bb78 0%, #276749 100%); color: white; border-color: transparent; }
</style>
